import { render } from "./BrandsList.vue?vue&type=template&id=695bee2e&scoped=true"
import script from "./BrandsList.vue?vue&type=script&lang=js"
export * from "./BrandsList.vue?vue&type=script&lang=js"

import "./BrandsList.vue?vue&type=style&index=0&id=695bee2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-695bee2e"

export default script